// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import cornerDownRightIcon from "@/assets/icons/corner-down-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CornerDownRightIconProps = Omit<IconProps, "name">;

export function CornerDownRightIcon(props: CornerDownRightIconProps): React.ReactNode {
  return <Icon name={cornerDownRightIcon} {...props} />;
}
